import * as moment from "moment";

const START_OF_MONTH = moment().startOf("month");
const FIRST_FRIDAY = moment(START_OF_MONTH).day(5);

function generateWeeklyDates(period): Date[] {
  const dates = [moment(FIRST_FRIDAY).toDate()];
  const endOfMonth = moment().endOf("month");

  let date = moment(FIRST_FRIDAY).add({ weeks: period });

  while (date.isBefore(endOfMonth)) {
    dates.push(date.toDate());
    date = date.add({ weeks: period });
  }

  return dates;
}

export { START_OF_MONTH, generateWeeklyDates };
